import React from 'react'
import { MuiTextfield } from 'material-ui-elements'
import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

const { theirRole } = commonConfigValues

const { helpers: { keepInLength, calculateFlag } } = core

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const actionStatus = [
  { id: 1, label: 'Cancelled - SW Decision' },
  { id: 2, label: 'Cancelled - Centre Decision' },
  { id: 3, label: 'Cancelled - Centre & SW Decision' },
  { id: 4, label: 'Completed - Action Ongoing' },
  { id: 5, label: 'Completed - No Further Action' },
  { id: 6, label: 'In Progress - Behind Schedule' },
  { id: 7, label: 'In Progress - On Schedule' },
  { id: 8, label: 'Pending - Behind Schedule' },
  { id: 9, label: 'Pending - On Schedule' }
]

export const valueTable = {
  actionStatus
}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'register.person.fullName',
      'placementPlan.date',
      'placementPlan.planDecisions',
      'placementPlan.action',
      'placementPlan.originalActionDueDate',
      'placementPlan.revisedActionDueDate',
      'placementPlan.status',
      'placementPlan.validFrom',
      'placementPlan.actionFlag'
    ]
  }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.personId',
    title: 'YP UI',
    minSpace: 'YP UIw ',
    formField: true
  },
  {
    name: 'register.person.firstName',
    title: 'YP First Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.lastName',
    title: 'YP Last Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.fullName',
    title: 'YP Name',
    formField: true,
    getCellValue: row =>
      `${row['register.person.firstName']} ${row['register.person.lastName']}`,
    maxChars: 100,
    minSpace: 'YP Name '
  },
  {
    name: 'placementPlan.date',
    title: 'Placement Plan Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Placement Plan '
  },
  {
    name: 'placementPlan.number',
    title: 'Placement Plan Number',
    formField: true,
    maxChars: 2,
    minSpace: 'Plan Number '
  },
  {
    name: 'placementPlan.planDecisions',
    title: 'Placement Plan Decisions',
    formField: true,
    maxChars: 500,
    minSpace: 'Placement Plan '
  },
  {
    name: 'placementPlan.action',
    title: 'Associated Action(s)',
    formField: true,
    maxChars: 500,
    minSpace: 'Associated Action(s) '
  },
  {
    name: 'placementPlan.responsiblePerson',
    title: 'Person Responsible for Implementing this Decision Name(s)',
    formField: true,
    maxChars: 50,
    minSpace: 'Implementing this Decision Name(s) '
  },
  {
    name: 'placementPlan.theirRole',
    title: 'Their Role',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`placementPlan.theirRole`], 10)])
        ? _.find(theirRole, [
            'id',
            parseInt(row[`placementPlan.theirRole`], 10)
          ]).label
        : row[`placementPlan.theirRole`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role '
  },
  {
    name: 'placementPlan.originalActionDueDate',
    title: 'Original Action Due Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Original Action '
  },
  {
    name: 'placementPlan.revisedActionDueDate',
    title: 'Revised Action Due Date (I/A)',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Revised Action '
  },
  {
    name: 'placementPlan.status',
    title: 'Action Status',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(actionStatus, ['id', parseInt(row[`placementPlan.status`], 10)])
        ? _.find(actionStatus, [
            'id',
            parseInt(row[`placementPlan.status`], 10)
          ]).label
        : row[`placementPlan.status`],
    options: 'actionStatus',
    filterField: true,
    minSpace: 'Action Status '
  },
  {
    name: 'placementPlan.validFrom',
    title: 'Action Status Valid at Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Action Status '
  },
  {
    name: 'placementPlan.actionFlag',
    title: 'Placement Plan Action Flags',
    formField: true,
    // type: 'boolean',
    filterField: true,
    minSpace: 'Placement Plan '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'placementPlan',
      historyName: 'placementPlanHistory',
      label: 'Register',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Register Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const person = _.find(availableValues.persons, ['id', o.personId])
            const label = `${person.firstName} ${person.lastName} (register: ${
              o.id
            })`
            return { value: o.id, label: label }
          })
        }
      ]
    },
    {
      id: 2,
      name: 'plp',
      activeName: 'placementPlan',
      historyName: 'placementPlanHistory',
      label: 'Placement Planning',
      icon: 'note',
      fields: [
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'placementPlan.date',
            label: 'Placement Plan Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'placementPlan.number',
            label: 'Placement Plan Number',
            normalize: v => {
              const val = keepInLength(v, 2)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'placementPlan.planDecisions',
          label: 'Placement Plan Decisions',
          normalize: v => {
            const val = keepInLength(v, 500)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'placementPlan.action',
          label: 'Associated Action(s)',
          normalize: v => {
            const val = keepInLength(v, 500)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        },
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'placementPlan.responsiblePerson',
            label: 'Person Responsible for Implementing this Decision Name(s)',
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'placementPlan.theirRole',
            label: 'Their Role',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required')
            // options: valueTable.theirRole.filter(f => f.id > 0).map(o => {
            //   return { value: o.id, label: o.label }
            // })
          }
        ],
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'placementPlan.originalActionDueDate',
            label: 'Original Action Due Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(
                formName,
                'placementPlan.actionFlag',
                calculateFlag(
                  (formValues &&
                    formValues.placementPlan &&
                    formValues.placementPlan.revisedActionDueDate) ||
                    v
                )
              )
            },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'placementPlan.revisedActionDueDate',
            label: 'Revised Action Due Date (I/A)',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(formName, 'placementPlan.actionFlag', calculateFlag(v))
            },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],

        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'placementPlan.status',
          label: 'Action Status',
          // multiple: true,
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: valueTable.actionStatus.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'placementPlan.validFrom',
          label: 'Action Status Valid at Date',
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          validate: v => (v ? undefined : 'Field is required')
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          component: v => (
            <MuiTextfield
              style={styles.fieldText}
              disabled={true}
              input={{
                floatingLabelStyle: { ...styles.floatingLabel }
              }}
              value={calculateFlag(
                (formValues &&
                  formValues.placementPlan &&
                  formValues.placementPlan.originalActionDueDate) ||
                  (formValues &&
                    formValues.placementPlan &&
                    formValues.placementPlan.revisedActionDueDate)
              )}
              label={'Placement Plan Action Flags'}
            />
          ),
          disabled: true,
          name: 'placementPlan.actionFlag',
          label: 'Placement Plan Action Flags'
        }
      ]
    }
  ]

  return forms
}

export const activeSection = ['placementPlan']

export const errors = [1, 2]

export const defaultNew = {
  placementPlan: {
    historyId: 'new'
  },
  placementPlanHistory: []
}

// "placementPlans": [
//   {
// "placementPlan": {
//   "id": 1,
//   "registerId": 1, //  ->  "personId": 2 -> person,
//   "date": "2001-01-01T23:28:56.782Z",
//   "number": "22",
//   "planDecisions": "aaa",
//   "action": "aaa",
//   "responsiblePerson": "aaa",
//   "theirRole": "aaa",
//   "originalActionDueDate": "2001-01-01T23:28:56.782Z",
//   "revisedActionDueDate": "2001-01-01T23:28:56.782Z",
//   "status" : 2,
//   "validFrom": "2001-01-01T23:28:56.782Z",
//   "actionFlag": 1
// },
// "placementPlanHistory": {

// }
//   }
// ]



// WEBPACK FOOTER //
// ./src/register/configs/placementPlans.js